import {apiRoot} from "./apiRoot.ts";
import {RIODateTime} from "../lib/RIODateTime.ts";
import {Driver} from "./driver.slice.ts";

export type ShiftActivity = {
    firstName: string,
    lastName: string,
    rioId: string
    type: string
    date: string
    startTime: string
    duration: number
    coDriver: boolean
    latitude: string
    longitude: string
}

export type Shift = {
    id: string,
    driverId: string,
    start: string,
    end: string,
    bookingDate: string,
    totalDuration: number,
    drivingDuration: number,
    workingDuration: number,
    bankHolidayDuration: number,
    lastUpdated: string,
    shiftType: string,
    driver: Driver,
    applicableSurcharges: Array<{
        name: string,
        duration: number
    }>,
    activities: Array<ShiftActivity>


}

export function toApiDate(date: RIODateTime) {
    return date.toPredefinedFormat(RIODateTime.PREDEFINED_FORMATS.DAY_ISO)
}

export const shiftSlice = apiRoot.injectEndpoints({
    endpoints: build => ({
        filteredByRioDriverIdAndTimeSpan: build.query<Shift[], { driverId: string, start: string, end: string }>({
            query: ({driverId, start, end}) => ({
                url: "/api/worktimeexpense/shift?driverId=" + driverId + "&startDate=" + (start) + "&endDate=" + (end),
                method: "GET"
            })
        }),
        shift: build.query<Shift, string>({
            query: (id) => `/api/worktimeexpense/shift/${id}`
        }),
    })
})

export const {
    useFilteredByRioDriverIdAndTimeSpanQuery,
    useShiftQuery,
} = shiftSlice